import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { environment } from '../../environments/environment'
import { AppService } from '../../service/app.service'
import { AtomModule } from '../../atom/atom.module'
import { AuthenticationService } from '../../service/authentication.service'

@Component({
  selector: 'app-apple-signin',
  templateUrl: './apple-signin.component.html',
  styleUrl: './apple-signin.component.less',
  standalone: true,
  imports: [AtomModule],
})
export class AppleSigninComponent implements OnInit {
  @Output() registerClick: EventEmitter<void> = new EventEmitter()
  @Output() token: EventEmitter<string> = new EventEmitter()
  @Output() buttonClick: EventEmitter<void> = new EventEmitter()

  @Input() pluginName = ''
  @Input() text = ''
  @Input() page = ''

  isBrowser: boolean

  constructor(
    private appService: AppService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {
    this.appService.isBrowser$.subscribe((state) => {
      this.isBrowser = state

      console.log(`redirecrURI: ${environment.APPLE_CALLBACK_URL}/auth/apple/callback`)
      
      if (this.isBrowser) {
        window['AppleID'].auth.init({
          clientId: environment.APPLE_CLIENT_ID,
          scope: 'name email',
          redirectURI: `${environment.APPLE_CALLBACK_URL}/auth/apple/callback`,
          state: `${this.page}`,
        })
      }
    })
  }

  login() {
    this.buttonClick.emit()
    console.log(`apple login`)
    window['AppleID'].auth.signIn()
  }
}
